import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    height: 50%;\n    z-index: 10;\n    border-radius: 0;\n    opacity: 1;\n  }\n\n  @media screen and (min-width: ", "px) {\n    margin-right: 16px;\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  > *:last-child {\n    margin: 0;\n  }\n\n  @media screen and (max-width: ", "px) {\n    flex: 1;\n    justify-content: flex-end;\n\n    ", ";\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n  @media screen and (max-width: ", "px) {\n    display: block;\n    ", ";\n  }\n\n  @media screen and (max-width: ", "px) {\n    right: 6px;\n\n    ", ";\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  @media screen and (max-width: ", "px) {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    display: block;\n    text-align: center;\n    margin: auto;\n    left: 0;\n\n    ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin: 0 auto;\n  > h2 {\n    margin: 0;\n    font-size: 14px;\n    line-height: 22px;\n  }\n\n  @media screen and (max-width: ", "px) {\n    text-align: center;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    white-space: nowrap;\n    position: relative;\n    flex: 1;\n    align-items: center;\n    left: 0;\n\n    ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 30px;\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n  @media screen and (max-width: ", "px) {\n    opacity: 0.6;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 22px;\n  }\n\n  ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: inline;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 22px;\n  margin: 0;\n\n  @media screen and (max-width: ", "px) {\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 16px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n  @media screen and (max-width: ", "px) {\n    flex: 1;\n    justify-content: flex-start;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: fixed;\n  left: 320px;\n  width: 100%;\n  line-height: 0.01px;\n  border-bottom: 1.5px solid ", ";\n  background-color: ", ";\n  @media screen and (min-width: ", "px) and (max-width: ", "px) {\n    left: 94px;\n  }\n  @media screen and (min-width: ", "px) and (max-width: 1050px) {\n    left: 230px;\n  }\n  &::after {\n    content: '\\a0';\n  }\n"], ["\n  ", "\n  position: fixed;\n  left: 320px;\n  width: 100%;\n  line-height: 0.01px;\n  border-bottom: 1.5px solid ", ";\n  background-color: ", ";\n  @media screen and (min-width: ", "px) and (max-width: ", "px) {\n    left: 94px;\n  }\n  @media screen and (min-width: ", "px) and (max-width: 1050px) {\n    left: 230px;\n  }\n  &::after {\n    content: '\\\\a0';\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  height: 100%;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: ", "px;\n  box-sizing: content-box;\n\n  @media screen and (min-width: ", "px) {\n    flex-wrap: wrap;\n  }\n\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    flex: 1;\n    ", ";\n    padding: 0 20px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        z-index: 20;\n        height: 64px;\n        position: fixed;\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        ", "\n        z-index: 20;\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  top: ", ";\n  ", "\n  ", "\n\n  height: 104px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  transition: height 0.1s;\n\n  ", ";\n\n  @media screen and (min-width: ", "px) {\n    ", "\n  }\n\n  @media screen and (min-width: ", "px) {\n    ", "\n\n    ", "\n  }\n\n  @media screen and (max-width: ", "px) {\n    background-color: ", ";\n    top: ", ";\n\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  min-height: ", ";\n\n  @media screen and (min-width: ", "px) {\n    ", "\n  }\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import MediaQuery from 'react-responsive';
import { useMediaQuery } from 'react-responsive';
import { AcornsIcon } from '@acorns/icons';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { useFeature } from '@optimizely/react-sdk';
import { ActionButton } from '../ActionButton';
import { A4_BackButton as BackButton } from '../A4_BackButton';
import { SettingsButton } from '../SettingsButton';
import { SavedLabel } from '../SavedLabel';
import styled, { css } from '../utils/styling/styled-components';
import { ACTION_STRIP } from '../utils/testing/TestIDs';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { theme } from '../theme';
import { handleBackAction } from '../utils/history';
import { ACTION_STRIP_SUBTEXT, ACTION_STRIP_TITLE, UNDERLINE } from '../utils/testing/TestIDs';
import { InvertedStrip } from './InvertedStrip';
import { useStickyScroll } from './hooks';
var Container = styled.div(_templateObject(), function (props) {
  return props.isNavEnabled && props.withSideNav ? '104px' : '63px';
}, theme.breakpoints.sm + 1, function (props) {
  return props.isNavEnabled && "position: sticky;\n     top: 0;\n     z-index: 20;\n  ";
}, theme.breakpoints.sm, function (props) {
  return props.showInverted && 'min-height: 0px';
});
var Content = styled.div(_templateObject2(), function (props) {
  return props.isNavEnabled ? 0 : "70px";
}, function (props) {
  return (!props.isNavEnabled || !props.withSideNav) && "\n    position: fixed;\n  ";
}, function (props) {
  return props.isNavEnabled && !props.withSideNav && "\n    @media screen and (min-width: ".concat(theme.breakpoints.md + 1, "px){\n      padding: 0 60px;\n    }\n    @media screen and (min-width: ").concat(theme.breakpoints.sm + 1, "px) and (max-width: ").concat(theme.breakpoints.md, "px){\n      padding: 0 30px;\n    }\n  ");
}, function (props) {
  return props.scrollPercent >= 0.1 && 'box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.04)';
}, theme.breakpoints.md + 1, function (props) {
  return !props.isNavEnabled && "top: 80px;";
}, theme.breakpoints.sm + 1, function (props) {
  return props.scrollPercent >= 0.1 && css(_templateObject3(), props.stripColor);
}, function (props) {
  return props.sticky && css(_templateObject4(), 104 - (104 - props.stickyHeight) * props.scrollPercent, !props.isNavEnabled && "position: fixed;");
}, theme.breakpoints.sm, function (props) {
  return props.stripColor;
}, function (props) {
  return props.isNavEnabled ? '0px' : "".concat(props.top, "px") || '69px';
}, function (props) {
  return props.sticky && css(_templateObject5());
});
var Constrainer = styled.div(_templateObject6(), function (props) {
  return props.maxWidth;
}, theme.breakpoints.sm + 1, function (props) {
  return !props.isNavEnabled && "\n    @media screen and (min-width: ".concat(theme.breakpoints.md + 1, "px) {\n      padding: 0 60px;\n    }\n\n    @media screen and (min-width: ").concat(theme.breakpoints.sm + 1, "px) and (max-width: ").concat(theme.breakpoints.md, "px) {\n      padding: 0 30px;\n    }\n  ");
}, theme.breakpoints.sm, function (props) {
  return props.customStyle ? props.customStyle : 'flex-wrap: wrap';
});
var Underline = styled.div(_templateObject7(), function (props) {
  return !props.isNavEnabled || !props.withSideNav ? "display: none;" : props.scrollPercent <= 0.1 && "display: none;";
}, function (props) {
  return props.theme.colors.ivory;
}, function (props) {
  return props.theme.colors.white;
}, function (props) {
  return props.theme.breakpoints.sm + 1;
}, function (props) {
  return props.theme.breakpoints.md;
}, function (props) {
  return props.theme.breakpoints.md + 1;
});
var TitleContainer = styled.div(_templateObject8(), theme.breakpoints.sm);
var Title = styled.h1(_templateObject9(), theme.colors.slate, theme.breakpoints.sm);
var Subtitle = styled.h2(_templateObject10(), theme.colors.slate, theme.breakpoints.md, function (props) {
  return props.sticky && "\n      text-align: center;\n      white-space: nowrap;\n    ";
}, theme.breakpoints.sm, function (props) {
  return props.customSubtextStyle && props.customSubtextStyle;
});
var VerticalSubTextContainer = styled.div(_templateObject11(), theme.breakpoints.sm, function (props) {
  return !props.hasActions && 'position: absolute; text-align: center; width: 100%;';
});
var HorizontalSubtextContainer = styled.div(_templateObject12(), theme.breakpoints.sm, function (props) {
  return !props.hasActions && 'position: absolute; text-align: center; width: 100%;';
});
var SettingsButtonStyled = styled(SettingsButton)(_templateObject13(), theme.breakpoints.md + 1, theme.breakpoints.md, function (props) {
  return props.sticky && "\n    background-color: transparent;\n    box-shadow: none;\n    right: 16px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    ";
}, theme.breakpoints.sm, function (props) {
  return props.sticky && "\n      right: 6px;\n    ";
});
var ActionContainer = styled.div(_templateObject14(), theme.breakpoints.sm, function (props) {
  return (props.sticky || props.showInverted) && !props.showMobileActions && "\n      display: none;\n    ";
});
var BackButtonStyled = styled(BackButton)(_templateObject15(), theme.breakpoints.sm, theme.breakpoints.sm + 1);
var defaultProps = {
  disableResponsiveSticky: false,
  maxWidth: 1200,
  preventDefault: false,
  showBack: true,
  showInverted: false,
  showResponsiveTitle: true,
  hasStickySettings: false,
  stripColor: theme.colors.white,
  invertedStripColor: theme.colors.green,
  invertedStripTransitionColor: theme.colors.white,
  showTitleOnLoad: false,
  showSubtextOnLoad: false,
  showChildrenIconsOnLoad: false,
  titleColorOnLoad: theme.colors.slate,
  subtextColorOnLoad: theme.colors.slate,
  stickyScroll: true,
  actionBackgroundColor: theme.colors.ivory,
  minWidthToShowButtonText: 600,
  withSideBarNav: false,
  leftActions: []
};

var ActionStrip = function ActionStrip(props) {
  var history = useHistory();
  var location = useLocation();
  var match = useRouteMatch();

  var _useFeature = useFeature('side_bottom_nav'),
      _useFeature2 = _slicedToArray(_useFeature, 1),
      isSBNavEnabled = _useFeature2[0];

  props = _objectSpread(_objectSpread({}, defaultProps), props);
  props.maxWidth = isSBNavEnabled ? !props.withSideBarNav || props.maxWidth < 1200 ? props.maxWidth : null : props.maxWidth;

  var _useStickyScroll = useStickyScroll({
    scrollDistance: 64
  }),
      scrollPercent = _useStickyScroll.scrollPercent;

  var isDesktop = useMediaQuery({
    query: "(min-width: ".concat(theme.breakpoints.sm + 1, "px)")
  });
  var hasMinViewWidth = useMediaQuery({
    query: "(min-width: ".concat(props.minWidthToShowButtonText, "px)")
  });
  var stickyHeight = isDesktop ? 64 : 56;

  var onBackPress = function onBackPress() {
    if (!props.preventDefault || !props.onBack) {
      handleBackAction({
        history: history,
        location: location,
        backOverride: props.backOverride,
        match: match
      });
    }

    if (props.onBack) {
      props.onBack();
    }
  };

  var VerticalSubtext = function VerticalSubtext(props) {
    return /*#__PURE__*/React.createElement(VerticalSubTextContainer, {
      hasActions: props.hasActions
    }, props.title && /*#__PURE__*/React.createElement(Title, {
      "data-testid": ACTION_STRIP_TITLE,
      customTitleStyle: props.customTitleStyle
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      "data-testid": ACTION_STRIP_SUBTEXT,
      sticky: props.sticky,
      customSubtextStyle: props.customSubtextStyle
    }, props.subtext));
  };

  var HorizontalSubtext = function HorizontalSubtext(props) {
    return /*#__PURE__*/React.createElement(HorizontalSubtextContainer, {
      hasActions: props.hasActions
    }, props.title && /*#__PURE__*/React.createElement(Title, {
      "data-testid": ACTION_STRIP_TITLE,
      customTitleStyle: props.customTitleStyle
    }, props.title), props.subtext && /*#__PURE__*/React.createElement(Subtitle, {
      "data-testid": ACTION_STRIP_SUBTEXT,
      sticky: props.stickyScroll,
      customSubtextStyle: props.customSubtextStyle
    }, " ".concat(props.subtext)));
  };

  return /*#__PURE__*/React.createElement(Container, {
    "data-testid": ACTION_STRIP,
    className: props.className,
    showInverted: props.showInverted,
    isNavEnabled: isSBNavEnabled,
    withSideNav: props.withSideBarNav
  }, props.showInverted ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, /*#__PURE__*/React.createElement(InvertedStrip, {
    leftActions: props.invertedLeftActions,
    stripColor: props.invertedStripColor,
    stripTransitionColor: props.invertedStripTransitionColor,
    stickyHeight: stickyHeight,
    scrollPercent: scrollPercent,
    onBack: onBackPress,
    showBack: props.showBack,
    subtext: props.invertedSubText,
    showTitleOnLoad: props.showTitleOnLoad,
    showSubtextOnLoad: props.showSubtextOnLoad,
    icon: props.icon,
    title: props.showResponsiveTitle ? props.invertedTitle : null,
    children: props.children,
    verticalSubText: props.verticalSubText,
    verticalScrollHeight: props.verticalScrollHeight || 6,
    scrollIcon: props.invertedScrollIcon,
    childrenIcons: props.invertedChildrenIcons,
    childrenIconsScrolled: props.invertedChildrenIconsScrolled,
    titleColorOnLoad: props.titleColorOnLoad,
    subtextColorOnLoad: props.subtextColorOnLoad,
    showChildrenIconsOnLoad: props.showChildrenIconsOnLoad
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, /*#__PURE__*/React.createElement(Content, {
    sticky: props.stickyScroll,
    stripColor: props.stripColor,
    top: props.top,
    scrollPercent: scrollPercent,
    stickyHeight: stickyHeight,
    isNavEnabled: isSBNavEnabled,
    withSideNav: props.withSideBarNav,
    "data-testid": 'action-strip-content'
  }, /*#__PURE__*/React.createElement(Constrainer, {
    maxWidth: props.maxWidth,
    customStyle: props.customStyle,
    isNavEnabled: isSBNavEnabled
  }, /*#__PURE__*/React.createElement(TitleContainer, null, /*#__PURE__*/React.createElement(React.Fragment, null, props.leftActions.map(function (action) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent ? /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent) : /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    }));
  })), props.showBack && props.leftActions.length === 0 && /*#__PURE__*/React.createElement(BackButtonStyled, {
    className: props.className,
    onClick: onBackPress
  }, props.backIcon || /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ArrowLeft,
    width: "17px",
    height: "12px"
  })), props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.stickyScroll,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), props.heading, /*#__PURE__*/React.createElement(ActionContainer, {
    customStyle: props.customStyle,
    sticky: props.stickyScroll,
    showInverted: props.showInverted
  }, props.action && props.action, props.actions && props.actions.map(function (action) {
    return /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))))) : /*#__PURE__*/React.createElement(Content, {
    top: props.top,
    stripColor: props.stripColor,
    scrollPercent: scrollPercent,
    sticky: props.stickyScroll,
    stickyHeight: stickyHeight,
    isNavEnabled: isSBNavEnabled,
    withSideNav: props.withSideBarNav,
    "data-testid": 'action-strip-content'
  }, /*#__PURE__*/React.createElement(Constrainer, {
    maxWidth: props.maxWidth,
    customStyle: props.customStyle,
    isNavEnabled: isSBNavEnabled
  }, /*#__PURE__*/React.createElement(TitleContainer, null, props.leftActions.map(function (action) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent ? /*#__PURE__*/React.createElement(React.Fragment, null, action.overrideComponent) : /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    }));
  }), props.showBack && props.leftActions.length === 0 && /*#__PURE__*/React.createElement(BackButtonStyled, {
    className: props.className,
    onClick: onBackPress
  }, props.backIcon || /*#__PURE__*/React.createElement(AcornsIcon, {
    icon: AcornsIcon.Icon.ArrowLeft,
    width: "17px",
    height: "12px"
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: theme.breakpoints.sm + 1
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, props) : /*#__PURE__*/React.createElement(HorizontalSubtext, props)), props.hasStickySettings && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, "Go to settings"), /*#__PURE__*/React.createElement(SettingsButtonStyled, {
    sticky: props.stickyScroll,
    onClick: props.onSettingsPress
  })), props.savedLabel && /*#__PURE__*/React.createElement(SavedLabel, {
    show: props.savedLabel.saved,
    text: props.savedLabel.text
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: theme.breakpoints.sm
  }, props.verticalSubText ? /*#__PURE__*/React.createElement(VerticalSubtext, _extends({}, props, {
    hasActions: !!(props.children || props.actions)
  })) : /*#__PURE__*/React.createElement(HorizontalSubtext, _extends({}, props, {
    hasActions: !!(props.children || props.actions)
  }))), props.heading, /*#__PURE__*/React.createElement(ActionContainer, {
    showMobileActions: props.showMobileActions,
    customStyle: props.customStyle,
    sticky: props.stickyScroll,
    showInverted: props.showInverted
  }, props.action && props.action, props.actions && props.actions.map(function (action) {
    return /*#__PURE__*/React.createElement(ActionButton, {
      danger: action.danger,
      actionBackgroundColor: action.actionBackgroundColor,
      key: action.id,
      icon: action.icon,
      text: hasMinViewWidth ? action.text : null,
      onPress: action.handler,
      tooltip: action.tooltip,
      actionText: action.actionText,
      testId: action.testId,
      className: action.className
    });
  }), props.children))), /*#__PURE__*/React.createElement(Underline, {
    scrollPercent: scrollPercent,
    isNavEnabled: isSBNavEnabled,
    withSideNav: props.withSideBarNav,
    "data-testid": UNDERLINE
  }));
};

export default ActionStrip;